import Vue from 'vue';

import CustomDataTable from './CustomDataTable';
Vue.component('CustomDataTable', CustomDataTable);
import CustomDraggable from './CustomDraggable';
Vue.component('CustomDraggable', CustomDraggable);
